export class VsMySetting {
    idClient: number;
    totalMessNotReaded: number = 0;
}
